export const courseConstants = {
    GETALL_REQUEST: 'COURSE_GETALL_REQUEST',
    GETALL_SUCCESS: 'COURSE_GETALL_SUCCESS',
    GETALL_FAILURE: 'COURSE_GETALL_FAILURE',

    DELETE_REQUEST: 'COURSE_DELETE_REQUEST',
    DELETE_SUCCESS: 'COURSE_DELETE_SUCCESS',
    DELETE_FAILURE: 'COURSE_DELETE_FAILURE'
};
